import { Fancybox } from './fancybox.esm.js';

/**
 * Binds Fancybox to the product media gallery's zoom triggers.
 *
 * Only loaded when a `_product-media-gallery` block has "Use Fancybox for zoom" enabled
 * (see snippets/product-media-gallery-content.liquid), so this never runs alongside the
 * theme's native zoom-dialog.
 *
 * Scoped to `[data-fancybox^="product-gallery-"]` so it can't collide with any other
 * Fancybox instance added elsewhere in the theme. Each gallery block gets its own group
 * ("product-gallery-{{ block_id }}"), so triggers within one product's gallery are grouped
 * together automatically.
 */
Fancybox.bind('[data-fancybox^="product-gallery-"]', {
  groupAll: false,
  // No image captions.
  caption: false,
  Images: {
    zoom: true,
  },
  // Only show the close button top-right; drop zoom/slideshow/fullscreen/thumbnail
  // toggles. The counter ("infobar", e.g. "3/10") stays on the left. Prev/next arrows
  // are the separate Carousel Navigation buttons and are unaffected by this.
  Toolbar: {
    display: {
      left: ['infobar'],
      middle: [],
      right: ['close'],
    },
  },
});
